/* SUNDAY BATCH · agent D (D-4 risk FS head picker) — EN + AR strings.
   Registered at the end of lib/i18n.js (one import + two _overrideDeep lines). ND-1 reuses existing labels (docs.title,
   dsD.engDocsTitle) and adds none. */
export const I18N_SBD = {
  en: {
    sbD: {
      fsHeads: "FS heads",
      fsHeadsHint: "The FS heads this risk is on (heat map, scoping, coverage).",
      addHead: "Add an FS head…",
      removeHead: "Remove {code}",
      notLinked: "Not linked — the heat map counts this risk on no FS head.",
      loadFailed: "The FS head list could not be loaded.",
    },
  },
  ar: {
    sbD: {
      fsHeads: "بنود القوائم المالية",
      fsHeadsHint: "بنود القوائم المالية التي يقع عليها هذا الخطر (الخريطة الحرارية، النطاق، التغطية).",
      addHead: "أضف بنداً من القوائم المالية…",
      removeHead: "إزالة {code}",
      notLinked: "غير مرتبط — لا تحتسب الخريطة الحرارية هذا الخطر على أي بند من القوائم المالية.",
      loadFailed: "تعذّر تحميل قائمة بنود القوائم المالية.",
    },
  },
};

export default I18N_SBD;
